import {forwardRef} from 'react';

import {SizeTokenValue} from 'common';

import {SVG} from './SVG';

import type {IconComponent} from 'icons/types';

const largeIcon = (
  <path d="M18.4 10.6C16.55 8.99 14.15 8 11.5 8C7.34004 8 3.76004 10.42 2.06004 13.93C1.74004 14.6 2.10004 15.4 2.81004 15.64C3.40004 15.84 4.04004 15.56 4.31004 15C5.61004 12.34 8.34004 10.5 11.5 10.5C13.45 10.5 15.23 11.22 16.62 12.38L14.71 14.29C14.08 14.92 14.52 16 15.41 16H21C21.55 16 22 15.55 22 15V9.41C22 8.52 20.92 8.07 20.29 8.7L18.4 10.6Z" />
);

const smallIcon = (
  <path d="M14.0651 5.565C14.0651 5.25296 13.8122 5 13.5001 5C13.1881 5 12.9351 5.25296 12.9351 5.565V8.83466C12.6957 8.53503 12.3875 8.18636 12.0131 7.83695C11.0191 6.90918 9.51264 5.935 7.5651 5.935C5.60709 5.935 4.21757 6.91894 3.33859 7.86555C2.89893 8.33903 2.57905 8.81074 2.3687 9.16414C2.2632 9.34138 2.18438 9.49034 2.13108 9.59694C2.10441 9.65028 2.08407 9.69314 2.06992 9.72378C2.06284 9.7391 2.05731 9.75137 2.0533 9.76039L2.04842 9.77144L2.04684 9.77508L2.04626 9.77642C2.04626 9.77642 2.04583 9.77744 2.56514 10L2.04583 9.77744C1.92291 10.0643 2.05577 10.3964 2.34259 10.5193C2.62906 10.6421 2.96076 10.5097 3.08402 10.2236L3.08446 10.2226L3.08581 10.2195L3.09577 10.1976C3.1053 10.177 3.12061 10.1446 3.14179 10.1023C3.18419 10.0175 3.24989 9.893 3.3397 9.74211C3.51997 9.43926 3.79382 9.03596 4.16665 8.63445C4.91264 7.83106 6.0231 7.065 7.5651 7.065C9.11755 7.065 10.3611 7.84082 11.2421 8.66305C11.6797 9.07152 12.0165 9.4813 12.2433 9.78865C12.264 9.81669 12.2838 9.84383 12.3026 9.87001H8.63011C8.31807 9.87001 8.06511 10.123 8.06511 10.435C8.06511 10.747 8.31807 11 8.63011 11H13.5001C13.8122 11 14.0651 10.747 14.0651 10.435V5.565Z" />
);

export const HistoryRedoIcon: IconComponent = forwardRef((props, ref) => {
  const {size} = props;

  return (
    <SVG ref={ref} name="HistoryRedo" {...props}>
      {!size || size === SizeTokenValue.Large || size === SizeTokenValue.Medium ? largeIcon : smallIcon}
    </SVG>
  );
});
